import { BaseApi } from "../../utils/BaseApi";
import { HttpMethodEnum } from "../models/HttpMethodEnum";
import {
  Questionnaire,
  QuestionnaireAssignPlansPayload,
  QuestionnaireCreatePayload,
  QuestionnaireSubmission,
  QuestionnaireSubmissionPayload,
  QuestionnaireEmbedTokenPayload,
  QuestionnaireEmbedTokenResponse,
  QuestionnaireUpdatePayload,
  QuestionnaireUserItem,
  QuestionnaireVersion,
  QuestionnaireVersionCreatePayload,
  QuestionnaireVersionSavePayload,
} from "../models/Questionnaire/QuestionnaireModel";

export class QuestionnaireApi extends BaseApi {
  private static instance: QuestionnaireApi;

  public static get(): QuestionnaireApi {
    if (!this.instance) {
      this.instance = new QuestionnaireApi();
    }
    return this.instance;
  }

  public adminList = BaseApi.createEndpoint<Questionnaire[], null>(
    HttpMethodEnum.GET,
    "/questionnaires/admin",
  );

  public embedToken = BaseApi.createEndpoint<
    QuestionnaireEmbedTokenResponse,
    QuestionnaireEmbedTokenPayload
  >(HttpMethodEnum.POST, "/questionnaires/embed-token");

  public adminCreate = BaseApi.createEndpoint<Questionnaire, QuestionnaireCreatePayload>(
    HttpMethodEnum.POST,
    "/questionnaires/admin",
  );

  public adminUpdate = BaseApi.createEndpoint<Questionnaire, QuestionnaireUpdatePayload>(
    HttpMethodEnum.PUT,
    "/questionnaires/admin",
  );

  public adminCreateVersion = BaseApi.createEndpoint<
    QuestionnaireVersion,
    QuestionnaireVersionCreatePayload
  >(HttpMethodEnum.POST, "/questionnaires/admin/version");

  public adminSaveVersion = BaseApi.createEndpoint<
    QuestionnaireVersion,
    QuestionnaireVersionSavePayload
  >(HttpMethodEnum.PUT, "/questionnaires/admin/version");

  public adminPublishVersion = BaseApi.createEndpoint<
    QuestionnaireVersion,
    { versionId: number }
  >(HttpMethodEnum.POST, "/questionnaires/admin/version/publish");

  public adminDisableVersion = BaseApi.createEndpoint<
    QuestionnaireVersion,
    { versionId: number }
  >(HttpMethodEnum.POST, "/questionnaires/admin/version/disable");

  public adminAssignPlans = BaseApi.createEndpoint<
    Questionnaire,
    QuestionnaireAssignPlansPayload
  >(HttpMethodEnum.PUT, "/questionnaires/admin/assignments");

  public assignedQuestionnaires = BaseApi.createEndpoint<
    QuestionnaireUserItem[],
    null
  >(HttpMethodEnum.GET, "/questionnaires/assigned");

  public questionnaireByCode = BaseApi.createEndpoint<
    QuestionnaireUserItem,
    { questionnaireCode: string }
  >(HttpMethodEnum.GET, "/questionnaires/code");

  public saveSubmission = BaseApi.createEndpoint<
    QuestionnaireSubmission,
    QuestionnaireSubmissionPayload
  >(HttpMethodEnum.POST, "/questionnaires/submission/save");

  public submitQuestionnaire = BaseApi.createEndpoint<
    QuestionnaireSubmission,
    QuestionnaireSubmissionPayload
  >(HttpMethodEnum.POST, "/questionnaires/submission/submit");
}

export const questionnaireApi = QuestionnaireApi.get();
